﻿import { APIConnector } from './modules/api.js'
import { BVKCalendar } from './modules/calendar.js'

const connection = new APIConnector('/api/', ['fields', "bookings"]);

let isLoggedIn = false;
let isAdmin = false;
let user = null;

const preInit = async () => {
    try {
        return connection.getData('fields').then(fields => {
            connection.getData('bookings').then(bookings => {
                return connection.data;
            })
        });
    } catch (error) {
        console.error(error);
    }
}

const prepareFields = (fields) => {
    return fields.map((f) => {
        if (f.number != 0) f.title = f.resource;
        return f;
    })

}

const init = async () => {
    try {
        await preInit();

        const fields = prepareFields(connection.data.fields);
        const dialogOptions = {
            domId: 'exampleModal',
            options: {
                startId: "DialogStart",
                startHourId: "DialogStartHours",
                fieldsId: "DialogField"


            }
        };
        const dialogOptions2 = {
            domId: 'otherModal',
            options: {
                startId: "DialogStart2",
                startHourId: "DialogStartHours2",
                fieldsId: "DialogField2"

            }
        }
        const calendarOptions = {
            targetItemId: 'calendar',
            resourceUri: null,
            resourceList: fields,
            eventUri: '/api/Bookings',
            initialView: null,
            dialogOptions: dialogOptions,
            dialogOptions2: dialogOptions2,
            isAdmin: isAdmin,
            isLoggedIn: isLoggedIn,
            userId: user,
            data: connection
        };
        const calendar = new BVKCalendar(calendarOptions);
        calendar.init('calendar');
        window.calendar = calendar;
        const button = document.createElement('button');
        button.type = "button";
        button.id = "theButton";
        button.innerHTML = "Buchen"
        document.getElementsByClassName("fc-today-button")[0].parentElement.appendChild(button);
        button.classList.add("fc-today-button")
        button.classList.add("fc-button")
        button.classList.add("fc-button-primary")
        button.addEventListener("click", () => { calendar._dialog.open() })
    } catch (error) {
        console.error(error);
    }

}
window.init = init;
window.onClose = () => {
    calendar._dialog.close();
    calendar._instance.refetchEvents()


}
window.setAdmin = () => {
    isAdmin = !isAdmin;
}
window.setLoggedIn = () => {
    isLoggedIn = !isLoggedIn;
}
window.setUserId = (userId) => {
    user = userId;
}
export default init;